import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f4fc146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-large font-600 mr-3" }
const _hoisted_2 = { class: "button-group-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "el-upload__default-btn",
  style: {"display":"none"}
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 上传合同 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 内容识别 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" AI评审 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 保存并提交 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存草稿 ")
const _hoisted_9 = { "element-loading-text": "正在获取数据，请稍后" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("不确定")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("付款计划")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("合同附件")

import {onMounted, reactive, ref, unref, watch, nextTick} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {storeToRefs} from 'pinia';
import {ElForm, ElNotification, ElMessage, ElMessageBox, FormRules,ElLoading, NotificationHandle} from 'element-plus';
import {useCtCategory} from '@/store/category.store';
import {useDictionary} from '@/store/dictionary.store';
import {useMainstay} from '@/store/mainstay.store';
import {useCurrency} from '@/store/currency.store';
import {useAppStore} from '@/store/app';
import {RmbcCpital} from '@/utils';
import {GetDraftEditDataApi, GetCtNumberApi} from '@/apis/contract/contract.api';
import {ContentRecognition, ContentReview, ContractDraftEditorsApi} from '@/apis/contract/contract.draft.api';
import {UploadApi} from '@/apis/materials/material.api';
import {GetTradeCacheListApi} from '@/apis/basics/trade.api';

import CtPayPlan from './components/payplan.vue';
import CtMaterial from './components/material.vue';
import CtAuditUser from './components/auditUser.vue';
import type {UploadInstance} from 'element-plus'
import moment from 'moment';
import {RelateContractApi} from '@/apis/contract/draft.api';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const login = useAppStore().getLoginInfo;

const cagegoryStore = useCtCategory();
const dicStore = useDictionary();
const cnyStore = useCurrency();
const {query} = useRoute();
const {go} = useRouter();

const {mainstayList} = storeToRefs(useMainstay());

const elFormRef = ref<InstanceType<typeof ElForm>>(); // El表单
const ctPayPlanRef = ref<InstanceType<typeof CtPayPlan>>(); // 付款计划
const ctMaterialRef = ref<InstanceType<typeof CtMaterial>>(); // 附件
const ctAuditUserRef = ref<InstanceType<typeof CtAuditUser>>(); // 审批人员

const state = reactive({
  notificationInstance: null as NotificationHandle | null,
  title: '新建合同(草稿)',
  loading: false,
  review: '', //评审内容
  uploadedFile: null,
  analysisMaterial: null as any,
  getNoLoad: false,
  disabledPartyb: false,
  categoryList: [] as any[],
  parytBList: [] as any[],
  contractList: [] as any[],
  rules: {
    no: [{required: true, message: '合同编号不能为空', trigger: 'blur'}],
    name: [{required: true, message: '合同名称不能为空', trigger: 'blur'}],
    category_id: [{required: true, message: '类别不能为空', trigger: 'change'}],
    mainstay_id: [{required: true, message: '我方主体未选择', trigger: 'change'}],
    begin_day: [{required: true, message: '请选择合同开始日期', trigger: 'blur'}],
    end_day: [{required: true, message: '请选择合同结束日期', trigger: 'blur'}],
    emp_used_list: [{required: true, message: '使用人员不能为空', trigger: 'change'}],
    emp_sign_list: [{required: true, message: '会签人员不能为空', trigger: 'change'}],
    emp_audit_list: [{required: true, message: '部门审核人员不能为空', trigger: 'change'}],
    phone: [{required: true, message: '联系电话不能为空', trigger: 'blur'}],
    remark: [{required: true, message: '合同摘要不能为空', trigger: 'blur'}],
    contract_limit: [{required: true, message: '请选择合同工期限类型', trigger: 'blur'}],
    contract_source: [{required: true, message: '请选择合同工订立来源', trigger: 'change'}],
    counterpart_id: [{required: true, message: '请选择相对方', trigger: 'change'}],
    amount_flag: [{required: true, message: '请选择金额类型', trigger: 'change'}],
    contract_amount: [{required: true, message: '请输入合同金额', trigger: 'blur'}],
    currency: [{required: true, message: '请选择币种', trigger: 'change'}],
    payment: [{required: true, message: '请选择付款方式', trigger: 'change'}],
    rel_contract_id: [{required: false, message: '请选择关联合同', trigger: 'change'}],
  } as FormRules,
});

const schema = ref<any>({
  category_id: '',
  amount_flag: 'Y',
  currency: 'RMB',
  contract_amount: 0.0,
  contract_limit: '1',
});

const load = {
  getContractNo: async () => {
    state.getNoLoad = true;
    const {data} = await GetCtNumberApi();
    schema.value.no = data || '';
    schema.value.code = data || '';

    state.getNoLoad = false;
  },
  /* 获取相对方数据 */
  getPartybList: async () => {
    state.disabledPartyb = true;
    const {succeeded, errors, data} = await GetTradeCacheListApi();
    if (!succeeded) {
      ElMessage.error(errors);
    } else {
      state.parytBList = (data || []).map((pb: any) => {
        return {label: pb.name, value: pb.id};
      });
    }
    state.disabledPartyb = false;
  },

  /* 获取可关联合同列表 */
  getRelateContractList: async () => {
    const {succeeded, errors, data} = await RelateContractApi();
    if (!succeeded) {
      ElMessage.error(errors);
    } else {
      state.contractList = data;
    }
  },

  /* 获取合同明细 */
  getDraftData: async (contractId: string) => {
    state.loading = true;

    const res = await GetDraftEditDataApi(contractId);
    const {succeeded, errors, data} = res;

    state.loading = false;

    if (!succeeded) {
      ElMessage.error(errors);
    } else {
      schema.value = Object.assign({}, data || {});

      /* 获取关联数据(审批人员) */

      const auditUserRef = unref(ctAuditUserRef);
      if (auditUserRef) {
        const createUserInfo = data.created_user_info || '';

        auditUserRef.setCreateInfo(createUserInfo);
        auditUserRef.setAuditUserList(data.id);
      }

      /* 获取关联数据(付款计划) */
      unref(ctPayPlanRef)?.setPlanList(data.id);

      /* 获取关联数据(附件) */
      unref(ctMaterialRef)?.setFileList(data.id);

      state.title = data.name;
      state.loading = false;
    }
  },
};

const actions = {
  /* 获取表单数据 */
  getFormData: async (isSubmit: boolean) => {
    const planRef = unref(ctPayPlanRef);
    const auditUserRef = unref(ctAuditUserRef);
    const materialRef = unref(ctMaterialRef);
    const subData = Object.assign({}, unref(schema), {is_submit: isSubmit});

    /* 审批人员列表 */
    subData['audit_user_list'] = await auditUserRef?.getAuditUserList();

    /* 付款计划 */
    if (subData.amount_flag == 'Y') {
      const planValid = planRef?.validate();
      if (!planValid?.isValid) {
        ElMessage.warning(planValid?.msg);
        state.loading = false;
        return;
      }
      subData['payplan_list'] = planRef?.getPlanList();
    }
    /* 合同附件 */
    const files = materialRef?.getFileList() ?? [];
    if (state.analysisMaterial?.id && !files.includes(state.analysisMaterial.id)) {
      files.push(state.analysisMaterial.id);
    }
    if (isSubmit && files.length <= 0) {
      ElMessage.warning('合同未上传附件');
      state.loading = false;
      return;
    }
    subData['file_list'] = files;
    return subData;
  },

  /* 保存草稿 */
  saveDraft: (isSubmit: boolean) => {
    unref(elFormRef)?.validate(async (valid: boolean) => {
      if (!valid) return;

      /* 提交数据 */
      state.loading = true;
      const subData = await actions.getFormData(isSubmit);
      console.log(subData)

      if (subData) {
        const onSuccess = (res: any) => {
          const {succeeded, errors} = res;
          if (!succeeded) {
            ElMessage.error(errors);
            state.loading = false;
          } else {
            ElMessage.success('保存成功');
            go(-1);
          }
        };

        const onFail = (err: any) => {
          ElMessage.error(err.message);
          state.loading = false;
        };

        const onFinally = () => {
          state.loading = false;
        };

        /* 草稿编辑接口 */
        ContractDraftEditorsApi(subData).then(onSuccess).catch(onFail).finally(onFinally);
      }
    });
  },
};

const changes = {
  /* 付款类别更变 */
  payment: (val: any) => {
    const payPlans = unref(ctPayPlanRef)?.getPlanList() ?? [];
    if (payPlans.length > 0) {
      const msg = '已设置付款计划的情况下，更改付款方式会清空已设置的付款计划，是否继续？';
      ElMessageBox.confirm(msg, '警告', {
        lockScroll: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        unref(ctPayPlanRef)?.clearPlan();
      });
    }
  },
};

const events = {
  onSourceChange: (val: any) => {
    if (val == "ZZHT" || val == "LXHT" || val == "BCHT") {
      state.rules.rel_contract_id = [{required: true, message: '请选择关联合同', trigger: 'change'}]
    } else {
      state.rules.rel_contract_id = [{required: false, message: '请选择关联合同', trigger: 'change'}]
    }
  },
}


/* 金额大写 */
watch(
  () => schema.value.contract_amount,
  (amount: number) => {
    schema.value.amount_big = RmbcCpital(amount);
  }
);

const handlechangev2 = (value) => {
  console.log(value, '666000')

}

onMounted(() => {
  state.categoryList = cagegoryStore.getTreeList();
  unref(schema).sign_day = moment().format('YYYY-MM-DD');

  const contractId = query.contractId as string;
  if (contractId) {
    load.getDraftData(contractId);
    load.getRelateContractList();
  } else {
    nextTick(() => {
      const auditUserRef = unref(ctAuditUserRef);
      if (auditUserRef) {
        auditUserRef.setCreateInfo(`${login.user_name}(${login.user_account})`);
      }
    });
    load.getContractNo();
    load.getRelateContractList();
  }

  nextTick(() => {
    unref(elFormRef)?.clearValidate();
  });

  load.getPartybList();
});

const uploadRef = ref<UploadInstance | null>(null)
const upSchemaNew = ref<any>({
  categroy_id: '0afff935-9ffa-4907-8ce8-a8bf3463b41e', // 固定这个分类
  ct_num: '',
  material_type: '',
  material_type_desc: '',
  file: null,
});

const handleFileChange = async (uploadFile: any) => {
  // 仅保留最新文件名称，自动覆盖之前的
  state.uploadedFile = uploadFile
  state.analysisMaterial = null
}

/**
 * 上传前校验（可选）：可限制文件类型、大小
 * @param file - 原生文件对象
 * @returns boolean - true继续，false终止
 */
const beforeUpload = async (file: File) => {
  // 示例：限制仅能上传pdf/word/excel文件
  const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
  if (!allowedTypes.includes(file.type)) {
    ElMessage.error('仅支持上传PDF、Word、Excel格式的合同文件！')
    return false  // 终止上传
  }
  // 示例：限制文件大小不超过10MB
  const maxSize = 10 * 1024 * 1024
  if (file.size > maxSize) {
    ElMessage.error('文件大小不能超过10MB！')
    return false  // 终止上传
  }
  return true  // 校验通过，继续
}

// 核心预览方法：新窗口打开文件，无修改
const previewFile = () => {
  const rawFile = state.uploadedFile.raw
  const fileUrl = URL.createObjectURL(rawFile)
  window.open(fileUrl, '_blank')
  // 释放临时链接，避免内存泄漏
  window.addEventListener('beforeunload', () => URL.revokeObjectURL(fileUrl))
}

const handleUploadClick = async () => {
  // 1. 有旧文件则弹覆盖提示，无则直接触发文件选择
  if (state.uploadedFile) {
    try {
      await ElMessageBox.confirm(
        '当前已存在上传文件，是否确认替换为新文件？',
        '提示',
        {
          confirmButtonText: '确认覆盖',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
    } catch (err) {
      ElMessage.info('已取消文件替换')
      return // 取消则终止，不触发文件选择
    }
  }


  const uploadEl = unref(uploadRef)?.$el
  if (uploadEl) {
    const fileInput = uploadEl.querySelector('.el-upload__input') as HTMLInputElement
    fileInput?.click() // 触发原生文件选择框
  }
}

const cardLoading = ref<boolean>(false);

const ensureAnalysisMaterial = async () => {
  if (state.analysisMaterial?.id) {
    return state.analysisMaterial;
  }

  if (!state.uploadedFile?.raw) {
    throw new Error('未上传文件！');
  }

  const materialType = dicStore.getSelectList('material_type')
    .find((item: any) => item.label === '合同正本');
  if (!materialType) {
    throw new Error('未找到合同文件类型配置');
  }

  const uploadData = new FormData();
  uploadData.append('file', state.uploadedFile.raw);
  uploadData.append('categroy_id', upSchemaNew.value.categroy_id);
  uploadData.append('ct_num', schema.value.no || '');
  uploadData.append('material_type', materialType.value);
  uploadData.append('material_type_desc', materialType.label);
  if (query.contractId) {
    uploadData.append('ct_id', query.contractId as string);
  }

  const res = await UploadApi(uploadData);
  if (!res?.succeeded || !res.data?.id) {
    throw new Error(res?.errors || '合同文件上传失败');
  }

  state.analysisMaterial = res.data;
  return res.data;
};

const createAnalysisFormData = async () => {
  if (!state.uploadedFile?.raw) {
    throw new Error('未上传文件！');
  }

  const material = await ensureAnalysisMaterial();
  const formData = new FormData();
  formData.append('file', state.uploadedFile.raw);
  formData.append('material_id', material.id);
  const fileUrl = material.file_url || material.fileUrl || material.FileUrl || material.url || '';
  if (fileUrl) {
    formData.append('file_url', fileUrl);
  }
  if (query.contractId) {
    formData.append('contract_id', query.contractId as string);
  }
  return formData;
};

const funForRecognise = async () => {
  if (state.uploadedFile == null) {
    ElMessage.error('未上传文件！')
    return
  }

  cardLoading.value = true
  try {
    const res = await ContentRecognition(await createAnalysisFormData());
    const data = res?.data?.data;
    if (!data) {
      ElMessage.warning('识别数据异常，无有效内容');
      return;
    }
    schema.value = {
      ...schema.value,
      name: data.contract_name || '',
      remark: data.contract_summary || '',
      begin_day: data.start_date || '',
      end_day: data.end_date || '',
      sign_day: data.sign_date || '',
      contract_amount: data.total_amount * 10000 || 0,
    };
    const matchOption = (list: any[], label: string) => list.find(itx => itx.label?.trim() === label?.trim());

    const pb = matchOption(state.parytBList, data.counter_party);
    pb ? (schema.value.counterpart_id = pb.value) : ElMessage.warning('未能匹配到合同中的相对方主体！');

    const foundItem = matchOption(mainstayList.value, data.our_party);
    foundItem ? (schema.value.mainstay_id = foundItem.value) : ElMessage.warning('未能匹配到合同中的我方主体！');
  } catch (error: any) {
    ElMessage.error(error?.message || '内容识别失败');
  } finally {
    cardLoading.value = false
  }
}

const funForReview = async () =>{
  if (state.uploadedFile == null) {
    ElMessage.error('未上传文件！')
    return
  }

  cardLoading.value = true
  try {
    const res = await ContentReview(await createAnalysisFormData());
    state.review = res.data.result
    openReview()
  } catch (error: any) {
    ElMessage.error(error?.message || 'AI评审失败');
  } finally {
    cardLoading.value = false
  }
}

const openReview = () => {
  // 动态插入样式（确保只插入一次）
  const styleId = 'custom-notification-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
      /* 设置通知宽度 */
      .custom-scrollable-notification {
        width: 600px !important;
        min-width: 600px !important;
        max-width: 90vw !important;
        border: 1px solid #ebeef5 !important; /* 边框颜色 */
        border-radius: 8px !important; /* 圆角 */
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important; /* 阴影 */
        background-color: #fff !important; /* 背景色 */
        padding: 15px !important; /* 内边距 */
      }

      /* 内容区域：固定高度 + 滚动条 */
      .custom-scrollable-notification .el-notification__content {
        max-height: 70vh !important; /* 最大高度为视口的70% */
        overflow-y: auto !important; /* 垂直滚动条 */
        white-space: pre-wrap !important; /* 保留换行和空格 */
        word-break: break-word !important; /* 长单词或URL换行 */
        line-height: 1.5 !important; /* 优化行高 */
        padding-right: 10px !important; /* 防止滚动条遮挡内容 */
      }

      /* 优化滚动条样式（可选） */
      .custom-scrollable-notification .el-notification__content::-webkit-scrollbar {
        width: 6px;
        background-color: #f5f5f5;
      }
      .custom-scrollable-notification .el-notification__content::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 3px;
      }
    `;
    document.head.appendChild(style);
  }

  // 打开通知
  // ElNotification({
  //   title: '评审建议',
  //   dangerouslyUseHTMLString: true,
  //   message: state.review,
  //   duration: 0, // 不自动关闭
  //   customClass: 'custom-scrollable-notification', // 应用自定义类名
  // });
  state.notificationInstance = ElNotification({
    title: '评审建议',
    dangerouslyUseHTMLString: true,
    message: state.review,
    duration: 0, // 不自动关闭
    customClass: 'custom-scrollable-notification', // 应用自定义类名
  });
};

const toggleNotification = () =>{
  if (state.notificationInstance) {
    // 如果已有通知实例，则关闭它
    state.notificationInstance.close();
    state.notificationInstance = null;
  } else {
    state.notificationInstance = ElNotification({
      title: '评审建议',
      dangerouslyUseHTMLString: true,
      message: state.review,
      duration: 0, // 不自动关闭
      customClass: 'custom-scrollable-notification', // 应用自定义类名
    });
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
    shadow: "never",
    "element-loading-text": "加载中..."
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_page_header, {
        onBack: _cache[24] || (_cache[24] = ($event: any) => (_unref(go)(-1)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(state).title), 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              class: "upload-btn",
              "show-file-list": false,
              "on-change": handleFileChange,
              "before-upload": beforeUpload,
              action: "#",
              "auto-upload": false,
              "on-error": ()=>{}
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["on-error"]),
            _createVNode(_component_el_button, {
              plain: "",
              style: {"color":"#409eff","background":"transparent"},
              onClick: handleUploadClick
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            (_unref(state).uploadedFile)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: "primary",
                  onClick: previewFile,
                  class: "file-name-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(state).uploadedFile.name), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "success",
              class: "ml-2",
              onClick: funForRecognise
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "success",
              class: "ml-2",
              onClick: funForReview
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              content: _unref(state).notificationInstance ? '收起评审建议' : '展示评审建议',
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  circle: "",
                  icon: _unref(state).notificationInstance ? 'Fold' : 'Expand' ,
                  onClick: toggleNotification
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["content"])
          ])
        ]),
        extra: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "pw-85",
            size: "small",
            type: "info",
            disabled: _unref(state).loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (actions.saveDraft(true)))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            class: "pw-85",
            size: "small",
            type: "primary",
            disabled: _unref(state).loading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (actions.saveDraft(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 18 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElForm), {
                      class: "mgt-20",
                      ref_key: "elFormRef",
                      ref: elFormRef,
                      size: "small",
                      "label-position": "top",
                      model: schema.value,
                      rules: _unref(state).rules
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 10 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "合同编号",
                                  prop: "no"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: schema.value.no,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schema.value.no) = $event)),
                                      placeholder: "合同编号",
                                      disabled: _unref(state).getNoLoad
                                    }, null, 8, ["modelValue", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "合同名称",
                                  prop: "name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: schema.value.name,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schema.value.name) = $event)),
                                      placeholder: "请输入合同名称"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "合同类型",
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_tree_select, {
                                      style: {"width":"100%"},
                                      modelValue: schema.value.category_id,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schema.value.category_id) = $event)),
                                      data: _unref(state).categoryList,
                                      accordion: "",
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "请选择合同分类",
                                      "default-expanded-keys": [schema.value.category_id]
                                    }, null, 8, ["modelValue", "data", "default-expanded-keys"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "订立来源",
                                  prop: "contract_source"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      style: {"width":"100%"},
                                      modelValue: schema.value.contract_source,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schema.value.contract_source) = $event)),
                                      placeholder: "请选择合同订立来源",
                                      onChange: events.onSourceChange
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dicStore).getSelectList('contract_source'), (cs) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: cs.label,
                                            value: cs.value
                                          }, null, 8, ["label", "value"]))
                                        }), 256))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "关联合同",
                                  prop: "rel_contract_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      style: {"width":"100%"},
                                      filterable: "",
                                      clearable: "",
                                      modelValue: schema.value.rel_contract_id,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schema.value.rel_contract_id) = $event)),
                                      placeholder: "请输入关联合同"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).contractList, (contract) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: contract.no,
                                            value: contract.id
                                          }, null, 8, ["label", "value"]))
                                        }), 256))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "合同期限类型",
                                  prop: "contract_limit"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: schema.value.contract_limit,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((schema.value.contract_limit) = $event)),
                                      style: {"width":"100%"},
                                      placeholder: "请选择合同期限类型"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_option, {
                                          label: "固定",
                                          value: "1"
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "非固定",
                                          value: "2"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, { gutter: 8 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "开始日期",
                                          prop: "begin_day"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: schema.value.begin_day,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schema.value.begin_day) = $event)),
                                              format: "YYYY-MM-DD",
                                              "value-format": "YYYY-MM-DD",
                                              placeholder: "请选择合同开始日期"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "结束日期",
                                          prop: schema.value.contract_limit == '1' ? 'end_day' : ''
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: schema.value.end_day,
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schema.value.end_day) = $event)),
                                              format: "YYYY-MM-DD",
                                              "value-format": "YYYY-MM-DD",
                                              placeholder: "请选择合同结束日期"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }, 8, ["prop"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "我方主体",
                                  prop: "mainstay_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select_v2, {
                                      modelValue: schema.value.mainstay_id,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schema.value.mainstay_id) = $event)),
                                      clearable: "",
                                      filterable: "",
                                      options: _unref(mainstayList),
                                      class: "w100",
                                      placeholder: "请选择我方主体",
                                      onChange: handlechangev2
                                    }, null, 8, ["modelValue", "options"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "相对方",
                                  prop: "counterpart_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select_v2, {
                                      modelValue: schema.value.counterpart_id,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schema.value.counterpart_id) = $event)),
                                      disabled: _unref(state).disabledPartyb,
                                      clearable: "",
                                      filterable: "",
                                      options: _unref(state).parytBList,
                                      class: "w100",
                                      placeholder: "请选择相对方"
                                    }, null, 8, ["modelValue", "disabled", "options"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "发起人电话",
                                  prop: "phone"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: schema.value.phone,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schema.value.phone) = $event)),
                                      maxlength: "13",
                                      placeholder: "请输入发起人电话"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "签订日期",
                                  prop: "sign_day"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      style: {"width":"100%"},
                                      modelValue: schema.value.sign_day,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schema.value.sign_day) = $event)),
                                      type: "date",
                                      format: "YYYY-MM-DD",
                                      "value-format": "YYYY-MM-DD",
                                      placeholder: "请录入签订日期"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "金额类型",
                                  prop: "amount_flag"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio_group, {
                                      modelValue: schema.value.amount_flag,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((schema.value.amount_flag) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_radio_button, { label: "Y" }, {
                                          default: _withCtx(() => [
                                            _hoisted_10
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_radio_button, { label: "N" }, {
                                          default: _withCtx(() => [
                                            _hoisted_11
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "摘要",
                                  prop: "remark"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: schema.value.remark,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((schema.value.remark) = $event)),
                                      rows: "6",
                                      "show-word-limit": "",
                                      maxlength: "300",
                                      type: "textarea"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (schema.value.amount_flag == 'Y')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_el_divider, { "content-position": "left" }, {
                                    default: _withCtx(() => [
                                      _hoisted_12
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 8 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, { gutter: 10 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 10 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, {
                                                label: "合同总额",
                                                prop: "contract_amount"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input_number, {
                                                    class: "txa-r w100",
                                                    modelValue: schema.value.contract_amount,
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((schema.value.contract_amount) = $event)),
                                                    min: "0",
                                                    max: 999999999,
                                                    controls: false,
                                                    precision: 2
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 14 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "金额大写" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: schema.value.amount_big,
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((schema.value.amount_big) = $event)),
                                                    disabled: "",
                                                    placeholder: "金额大写"
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 16 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, { gutter: 10 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, {
                                                label: "币种",
                                                prop: "currency"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_select, {
                                                    class: "w100",
                                                    modelValue: schema.value.currency,
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((schema.value.currency) = $event)),
                                                    filterable: "",
                                                    clearable: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cnyStore).getSelectList(), (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          label: item.label,
                                                          value: item.value
                                                        }, null, 8, ["label", "value"]))
                                                      }), 256))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 12 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, {
                                                label: "付款方式",
                                                prop: "payment"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_select, {
                                                    class: "w100",
                                                    modelValue: schema.value.payment,
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((schema.value.payment) = $event)),
                                                    placeholder: "付款方式",
                                                    onChange: changes.payment
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_option, {
                                                        label: "按月",
                                                        value: "M"
                                                      }),
                                                      _createVNode(_component_el_option, {
                                                        label: "分段",
                                                        value: "F"
                                                      }),
                                                      _createVNode(_component_el_option, {
                                                        label: "一次性",
                                                        value: "Y"
                                                      }),
                                                      _createVNode(_component_el_option, {
                                                        label: "其他",
                                                        value: "QT"
                                                      })
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue", "onChange"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(CtPayPlan, {
                                        ref_key: "ctPayPlanRef",
                                        ref: ctPayPlanRef,
                                        amount: schema.value.contract_amount,
                                        "onUpdate:amount": _cache[20] || (_cache[20] = ($event: any) => ((schema.value.contract_amount) = $event)),
                                        payment: schema.value.payment,
                                        "onUpdate:payment": _cache[21] || (_cache[21] = ($event: any) => ((schema.value.payment) = $event))
                                      }, null, 8, ["amount", "payment"])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_divider, { "content-position": "left" }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(CtMaterial, {
                                  ref_key: "ctMaterialRef",
                                  ref: ctMaterialRef
                                }, null, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(CtAuditUser, {
                      ref_key: "ctAuditUserRef",
                      ref: ctAuditUserRef,
                      categoryId: schema.value.category_id,
                      "onUpdate:categoryId": _cache[22] || (_cache[22] = ($event: any) => ((schema.value.category_id) = $event)),
                      mainstayId: schema.value.mainstay_id,
                      "onUpdate:mainstayId": _cache[23] || (_cache[23] = ($event: any) => ((schema.value.mainstay_id) = $event))
                    }, null, 8, ["categoryId", "mainstayId"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])), [
            [_directive_loading, _unref(state).loading]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_loading, cardLoading.value]
  ])
}
}

})